"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dispatchLanguage = exports.SessionStoreManager = exports.BackendManager = void 0;
const elements_core_event_bus_1 = require("@hydrogen/elements.core.event-bus");
const constants_1 = require("../constants");
var backend_manager_1 = require("./backend-manager");
Object.defineProperty(exports, "BackendManager", { enumerable: true, get: function () { return backend_manager_1.BackendManager; } });
var session_store_manager_1 = require("./session-store-manager");
Object.defineProperty(exports, "SessionStoreManager", { enumerable: true, get: function () { return session_store_manager_1.SessionStoreManager; } });
const dispatchLanguage = (language) => (0, elements_core_event_bus_1.post)(constants_1.LANGUAGE_TOPIC, { language });
exports.dispatchLanguage = dispatchLanguage;
//# sourceMappingURL=index.js.map